module.exports = __webpack_public_path__ + "img/carpenter-pool.dac0fb05.webp";